import "./WashingtonDC.module.css";
import Header from "@/reusable_sections/Header";
import HeroWashingtonDC from "./sections/HeroWashingtonDC";
import DcAreas from "./sections/DcAreas";
import EmergencyAction from "./sections/EmergencyAction";
import Footer from "@/reusable_sections/Footer";
export default function WashingtonDCPage() {
  return <div>
      <Header />
      <HeroWashingtonDC />
      <DcAreas />
      <EmergencyAction />
      <Footer />
    </div>;
}